class CustomerInvite {
  constructor() {
    this.scriptElement = document.querySelector('[data-customer-invite="true"]');
    if (!this.scriptElement) {
      return;
    }
    
    this.locale = this.scriptElement.getAttribute('data-locale');

    this.form = document.querySelector('fr' === this.locale ? 'form[action="/fr/account/recover"]' : 'form[action="/account/recover"]');
    if (!this.form) {
      console.log('[Customer Invite] Form not found');
      return;
    }

    this.emailInput = document.getElementById('RecoverEmail');
    if (!this.emailInput) {
      return;
    }

    const giftlistDomain = (window.DreambabyConfig && window.DreambabyConfig.giftlistDomain);
    const proxyToken = (window.DreambabyConfig && window.DreambabyConfig.proxyToken);

    
    this.endpointUrl = `${giftlistDomain}/proxy/shopify-admin/customer-invite?authorization=fixed`;
    
    this.customerMailHandler = new DreambabyCustomerMailHandler({
      endpointUrl: this.endpointUrl,
      proxyToken: proxyToken
    });

    this.init();
  }

  init() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const email = this.emailInput.value;

    if (!email || !email.trim()) {
      this.form.submit();
      return;
    }

    await this.customerMailHandler.triggerActivateAccount(email);
    setTimeout(() => {
      this.form.submit();
    }, 500);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CustomerInvite();
});
